<app-banner-alert
  *ngIf="alert$ | async | isBannerTypeAlert"
  [alert]="alert$ | async"
  (dismissClicked)="dismissClicked.emit()"
  (learnMoreClicked)="learnMoreClicked.emit()" />
<app-card-alert *ngIf="alert$ | async | isCardTypeAlert" [alert]="alert$ | async" />
